import axios from 'axios';
import _ from 'lodash';
// import { logoutUser } from '../actions/AuthActions'
// import { showAlert } from '../actions/alert/alert-actions'

// import { ALERT_TYPE } from '../components/alert/Alert'
export const UUID = 'e5bef57e-b0a4-11ea-b3de-0242ac130004';

export let BASE_URL;

if (
  process.env.REACT_APP_BASE_API_URL &&
  process.env.REACT_APP_BASE_API_URL.length
) {
  BASE_URL = process.env.REACT_APP_BASE_API_URL;
} else {
  console.error(
    'Environment variable REACT_APP_BASE_API_URL is not defined. Please add it to the .env file and restart the app.'
  );
}

const callApi = (endpoint, config) => {
  const token = localStorage.getItem(UUID) || null;
  // axios.defaults.withCredentials = true
  axios.defaults.responseType = 'text';
  config &&
    _.forEach(Object.keys(config), (key) => {
      if (key !== 'data' && key !== 'method') {
        axios.defaults[key] = config[key];
      }
    });

  axios.defaults.headers.common['Content-Type'] = 'application/json';
  if (token) {
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  return axios
    .request(endpoint, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const CALL_API = 'Call API';

export const api = (store) => (next) => (action) => {
  const {
    auth: { token }
  } = store.getState();
  // const token = null
  const callAPI = action[CALL_API];

  if (!callAPI) {
    return next(action);
  }

  const { endpoint, types, config, ...params } = callAPI;
  const [requestType, successType, errorType] = types;

  next({
    config: config,
    type: requestType,
    ...params
  });

  function status(response, store) {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response);
    } else {
      if (response?.response && response?.response?.status === 429) {
        const message = response.response.data.message;
        switch (response.response.data.error) {
          case 'ACCESS_TOKEN_EXPIRED':
          case 'INVALID_ACCESS_TOKEN': {
            // if (store.getState().auth.token) {
            //   store.dispatch(logoutUser(message))
            // }
            return Promise.reject(message);
          }
          default: {
            // store.dispatch(showAlert(ALERT_TYPE.danger, '', message, 0, response.data))
            // return Promise.reject(message)
            return Promise.reject(message);
          }
        }
      }

      if (response.data) {
        const message = response.data.message;
        switch (response.data.error_definition) {
          case 'ACCESS_TOKEN_EXPIRED':
          case 'INVALID_ACCESS_TOKEN': {
            // if (store.getState().auth.token) {
            //   store.dispatch(logoutUser(message))
            // }
            return Promise.reject(message);
          }
          default: {
            // store.dispatch(showAlert(ALERT_TYPE.danger, '', message, 0, response.data))
            // return Promise.reject(message)
            return;
          }
        }
      }

      if (response.response.data) {
        const message = response.response.data.message;
        switch (response.data?.error_definition) {
          case 'ACCESS_TOKEN_EXPIRED':
          case 'INVALID_ACCESS_TOKEN': {
            // if (store.getState().auth.token) {
            //   store.dispatch(logoutUser(message))
            // }
            return Promise.reject(message);
          }
          default: {
            // store.dispatch(showAlert(ALERT_TYPE.danger, '', message, 0, response.data))
            // return Promise.reject(message)
            return Promise.reject(message || 'Something went wrong!');
          }
        }
      }

      // if (response.response) {
      //   message = response.response.data.message;
      //   switch (response.response.data.error) {
      //     case 'ACCESS_TOKEN_EXPIRED':
      //     case 'INVALID_ACCESS_TOKEN': {
      //       // if (store.getState().auth.token) {
      //       //   store.dispatch(logoutUser(message))
      //       // }
      //       return Promise.reject(message);
      //     }
      //     default: {
      //       // store.dispatch(showAlert(ALERT_TYPE.danger, '', message, 0, response.data))
      //       // return Promise.reject(message)
      //       return Promise.reject(message);
      //     }
      //   }
      // }
    }
  }

  return callApi(endpoint, config, token)
    .then(status)
    .then(({ data, headers, status }) => {
      if (status < 200 || status > 300) {
        next({
          errorMessage: 'There was an error',
          type: errorType,
          ...params
        });
      } else {
        next({
          data,
          headers,
          config,
          type: successType,
          ...params
        });
      }
    })
    .catch((error) => {
      console.log('err', error);
      if (error.response) {
        status(error.response, store);
        if (error.response.status === 401) {
          localStorage.clear();
          if (!(window.location.pathname === '/login')) {
            window.location = '/login';
          }
        }
      } else {
        if (config) {
          if (!config.suppress_error_message) {
            // store.dispatch(showAlert(ALERT_TYPE.danger, '', error.message))
          }
        } else {
          // store.dispatch(showAlert(ALERT_TYPE.danger, '', error.message))
        }
      }

      next({
        type: errorType,
        config: config,
        ...params,
        error
      });
    });
};
